import React from 'react';

import './BattaryCell.scss';

interface BattaryCellProps {
  percentage: number;
}

const BattaryCell: React.FC<BattaryCellProps> = ({ percentage }) => {
  return <div className={`d-flex justify-content-center ${percentage <= 10 ? 'text-danger' : ''}`}>{percentage}</div>;
};

export default BattaryCell;
